import { ActionLink } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

type TUserCardDesktopBlockedChatProps = {
  handleClickSpam: () => void;
};

export const UserCardDesktopBlockedChat: React.FC<TUserCardDesktopBlockedChatProps> = ({ handleClickSpam }) => {
  return (
    <div className={styles['container']} data-testid="UserCardDesktopBlockedChat">
      <ActionLink onClick={handleClickSpam} fontSize="M" fontWeight="bold" color="negative">
        Заблокировать чат
      </ActionLink>
    </div>
  );
};
